'use client'

import { useTexture } from '@react-three/drei'
import gsap from 'gsap'
import { useWindowSize } from 'hamo'
import { useEffect, useRef, useState } from 'react'
import { LinearFilter, PlaneGeometry } from 'three'
import { useMouseMove } from '~/hooks/use-mouse-move'
import { clamp, mapRange } from '~/libs/maths'
import { useWebGLRect } from '~/webgl/hooks/use-webgl-rect'
import { DepthMaterial } from './material'

export function WebGLDepthImage({ rect, src = '', depthSrc = '', onLoad }) {
  const meshRef = useRef()

  useWebGLRect(rect, ({ scale, position, rotation }) => {
    meshRef.current.position.set(position.x, position.y, position.z)
    meshRef.current.rotation.set(rotation.x, rotation.y, rotation.z)
    meshRef.current.scale.set(scale.x, scale.y, scale.z)
    meshRef.current.updateMatrix()
  })

  const [geometry] = useState(() => new PlaneGeometry(1, 1, 1))
  const [material] = useState(() => new DepthMaterial())

  useTexture(src, (texture) => {
    texture.minFilter = texture.magFilter = LinearFilter

    material.texture = texture
  })
  useTexture(depthSrc, (texture) => {
    texture.minFilter = texture.magFilter = LinearFilter

    material.depthTexture = texture
  })

  useEffect(() => {
    onLoad?.()
  }, [])

  useEffect(() => {
    gsap.to(material.uniforms.uAppear, {
      value: 1,
      duration: 4,
      ease: 'expo.out',
    })
  }, [material.uniforms.uAppear])

  const { width: windowWidth, height: windowHeight } = useWindowSize()

  useMouseMove(
    ({ clientX, clientY }) => {
      if (typeof windowWidth === 'undefined' || typeof windowHeight === 'undefined') return

      // const minX = rect.left
      // const maxX = rect.left + rect.width
      // const x =
      let x = mapRange(rect.left, rect.left + rect.width, clientX, -1, 1)
      let y = mapRange(rect.top, rect.top + rect.height, clientY, -1, 1)

      x = clamp(-1, x, 1)
      y = -clamp(-1, y, 1)

      // console.log()

      // return

      // const x = (clientX / windowWidth) * 2 - 1
      // const y = -(clientY / windowHeight) * 2 + 1

      const intensity = 0.009

      gsap.to(material.offset, {
        x: x * intensity,
        y: y * intensity,
        duration: 4,
        ease: 'expo.out',
      })

      // material.offset.set(x * 0.005, y * 0.005)
    },
    [windowWidth, windowHeight, rect]
  )

  return (
    <>
      <mesh
        matrixAutoUpdate={false}
        ref={(node) => {
          meshRef.current = node
          node?.updateMatrix()
        }}
        geometry={geometry}
        material={material}
      />
    </>
  )
}
